/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { PropertyDetailTabNames } from "./props";
import { AppPermissions, useHasPermission } from "../../core";

export interface CustomProps {
  tabName: PropertyDetailTabNames;
  tabChangeHandler: (tabName: PropertyDetailTabNames) => void;
}

const PropertyDetailTabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<PropertyDetailTabNames>(
    props.tabName || PropertyDetailTabNames.Overview
  );
  const setElementActive = (tabValue: PropertyDetailTabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  const canViewTenancyOrLease = useHasPermission(AppPermissions.ViewTenancy);

  return (
    <ul
      className="nav tab-underline mb-3 border-bottom font-sm font-weight-semibold flex-nowrap text-nowrap overflow-auto px-md-0 px-3 w-100"
      id="activity-tab"
      role="tablist"
    >
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${tabName === PropertyDetailTabNames.Overview
              ? "active"
              : "text-gray-600"
            }`}
          onClick={(e) => setElementActive(PropertyDetailTabNames.Overview)}
        >
          <span className=" py-1 d-inline-flex">Overview</span>
        </a>
      </li>
      {canViewTenancyOrLease &&
        <li className="nav-item pr-4" role="presentation">
          <a
            className={`cursor-pointer nav-link position-relative px-0 py-2  ${tabName === PropertyDetailTabNames.UnitInfo
                ? "active"
                : "text-gray-600"
              }`}
            onClick={(e) => setElementActive(PropertyDetailTabNames.UnitInfo)}
          >
            <span className=" py-1 d-inline-flex">Unit/Tenant Info</span>
          </a>
        </li>
      }
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${tabName === PropertyDetailTabNames.Activities
              ? "active"
              : "text-gray-600"
            }`}
          onClick={(e) => setElementActive(PropertyDetailTabNames.Activities)}
        >
          <span className=" py-1 d-inline-flex">Activities</span>
        </a>
      </li>
      {/* <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${tabName === PropertyDetailTabNames.LocationMap
              ? "active"
              : "text-gray-600"
            }`}
          onClick={(e) => setElementActive(PropertyDetailTabNames.LocationMap)}
        >
          <span className=" py-1 d-inline-flex">Location Map </span>
        </a>
      </li> */}
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${tabName === PropertyDetailTabNames.Log ? "active" : "text-gray-600"
            }`}
          onClick={(e) => setElementActive(PropertyDetailTabNames.Log)}
        >
          <span className=" py-1 d-inline-flex">Log </span>
        </a>
      </li>
    </ul>
  );
};

export default PropertyDetailTabs;
